import Demo from './demo.vue'
Demo.install = (Vue) => {
  Vue.component(Demo.name, Demo)
}

export default Demo



// WEBPACK FOOTER //
// ./src/components/wfl-demo/index.js